export default "__VITE_PUBLIC_ASSET__67e36b06__"